/** @format */

// import { configureStore } from "@reduxjs/toolkit";
import store from "./storeSetup";
// import settingReducer from "./setting/reducers";
// import sessionReducer from "./auth/reducer";
export * from "./setting/reducers";
export * from "./auth/reducer";
export * from "./role/reducer";
// export * from "./mode/reducer";
export * from "./locale/reducer";
export default store;
